import api from './api';

// The Twine: what the team knows, kept on each record.
export const twineAPI = {
  list: (subject, status) => api.get('/api/twine', { params: { subject_type: subject.type, subject_id: subject.id, ...(status ? { status } : {}) } }),
  review: () => api.get('/api/twine/review'),
  reviewCount: () => api.get('/api/twine/review/count'),
  context: (subject) => api.get('/api/twine/context', { params: { subject_type: subject.type, subject_id: subject.id } }),
  add: (subject, text, kind = 'fact') => api.post('/api/twine', { subject: { type: subject.type, id: subject.id }, text, kind }),
  mend: (source_type, source_id) => api.post('/api/twine/mend', { source_type, source_id }),
  update: (id, data) => api.patch(`/api/twine/${id}`, data),
  remove: (id) => api.delete(`/api/twine/${id}`),
};

export const TWINE_KINDS = [
  { id: 'fact', label: 'Fact' },
  { id: 'preference', label: 'Preference' },
  { id: 'decision', label: 'Decision' },
  { id: 'date', label: 'Date' },
  { id: 'person', label: 'Person' },
  { id: 'caution', label: 'Caution' },
];

export const SOURCE_LABEL = { yarn: 'Yarn', interview: 'Interview', activity: 'Activity', manual: 'Added by hand', desk: 'Desk agent' };

// Tell the sidebar badge to refresh after a strand is kept or dismissed
export const twineChanged = () => { try { window.dispatchEvent(new Event('twine-changed')); } catch (e) { /* ignore */ } };
